/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DigitizingserviceMelcoDigitizingModelsOrderDesignAdaptions
 */
export interface DigitizingserviceMelcoDigitizingModelsOrderDesignAdaptions {
    /**
     * 
     * @type {boolean}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderDesignAdaptions
     */
    optimize_lettering?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderDesignAdaptions
     */
    enforce_letter_size?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderDesignAdaptions
     */
    substitute_small_fonts?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderDesignAdaptions
     */
    enlarge_small_objects?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderDesignAdaptions
     */
    simplify_design?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderDesignAdaptions
     */
    drop_micro_elements?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderDesignAdaptions
     */
    reduce_colour_count?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DigitizingserviceMelcoDigitizingModelsOrderDesignAdaptions
     */
    convert_gradients_shadows?: boolean;
}

export function DigitizingserviceMelcoDigitizingModelsOrderDesignAdaptionsFromJSON(json: any): DigitizingserviceMelcoDigitizingModelsOrderDesignAdaptions {
    return DigitizingserviceMelcoDigitizingModelsOrderDesignAdaptionsFromJSONTyped(json, false);
}

export function DigitizingserviceMelcoDigitizingModelsOrderDesignAdaptionsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingserviceMelcoDigitizingModelsOrderDesignAdaptions {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'optimize_lettering': !exists(json, 'optimize_lettering') ? undefined : json['optimize_lettering'],
        'enforce_letter_size': !exists(json, 'enforce_letter_size') ? undefined : json['enforce_letter_size'],
        'substitute_small_fonts': !exists(json, 'substitute_small_fonts') ? undefined : json['substitute_small_fonts'],
        'enlarge_small_objects': !exists(json, 'enlarge_small_objects') ? undefined : json['enlarge_small_objects'],
        'simplify_design': !exists(json, 'simplify_design') ? undefined : json['simplify_design'],
        'drop_micro_elements': !exists(json, 'drop_micro_elements') ? undefined : json['drop_micro_elements'],
        'reduce_colour_count': !exists(json, 'reduce_colour_count') ? undefined : json['reduce_colour_count'],
        'convert_gradients_shadows': !exists(json, 'convert_gradients_shadows') ? undefined : json['convert_gradients_shadows'],
    };
}

export function DigitizingserviceMelcoDigitizingModelsOrderDesignAdaptionsToJSON(value?: DigitizingserviceMelcoDigitizingModelsOrderDesignAdaptions | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'optimize_lettering': value.optimize_lettering,
        'enforce_letter_size': value.enforce_letter_size,
        'substitute_small_fonts': value.substitute_small_fonts,
        'enlarge_small_objects': value.enlarge_small_objects,
        'simplify_design': value.simplify_design,
        'drop_micro_elements': value.drop_micro_elements,
        'reduce_colour_count': value.reduce_colour_count,
        'convert_gradients_shadows': value.convert_gradients_shadows,
    };
}


